module.exports = __webpack_public_path__ + "img/logo-ledger.029667b4.svg";